import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/Home/App';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useCookies } from 'react-cookie';
import Search from './pages/Search/Search';
import Contact from './pages/Contact/Contact';
import Settings from './pages/Settings/Settings';
import VideoPage from './pages/Video/video';
import SignInPage from './pages/SignIn/SignIn';
import SignUpPage from './pages/SignUp/Signup';
import ChannelPage from './pages/Channel/Channel';
import NotFound from './pages/NotFound/NotFound';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      <Route index element={<App />} />
      <Route path="/search" element={<Search />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/video" element={<VideoPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/channel" element={<ChannelPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
)


function Logout() {
  const [removeCookie] = useCookies();
  useEffect( () => {
    removeCookie("token");
    window.location = "/";
  }, [removeCookie]);
  return <></>
}